export const name = 'backgroundGroup' as const
